export default __webpack_public_path__ + "static/media/connectMoreAccountIcon.5e61653e.svg";